<template>
  <div class="donation-options mb-4">
    <div class="donation-options__item d-flex flex-column">
      <div
        class="donation-options__header pl-3 pr-3 pt-2 pb-2 d-flex align-items-center"
      >
        <span class="donation-options__title">{{ title }}</span>
      </div>
      <div class="donation-options__description pl-3 pr-3 mt-3">
        <p class="mb-0">{{ description }}</p>
      </div>
      <span class="donation-options__backers-info pl-3 mt-1">
        <b>Backers:</b> {{ backers || 0 }}
      </span>
      <span
        v-if="type !== 'noReward'"
        class="donation-options__backers-info pl-3"
      >
        <b>Est. Availability:</b> {{ formattedAvailabilityDate }}
      </span>

      <br />

      <div class="row m-0 d-flex justify-content-between pl-3 pr-3 pb-3">
        <slot name="price-info" />
        <slot name="button" />
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'DonationOptions',

  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    backers: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    availabilityDate: {
      type: String,
      default: null
    }
  },

  computed: {
    formattedAvailabilityDate() {
      return this.availabilityDate
        ? dayjs(this.availabilityDate).format('MMMM YYYY')
        : null;
    }
  }
};
</script>

<style lang="scss">
.donation-options {
  &__item {
    background-color: $white-color;
    border-radius: 14px;
  }

  &__header {
    background-color: $primary-purple-color;
    font-size: 18px;
    font-weight: 600;
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
    min-height: 45px;
  }

  &__description {
    color: $dark-color;
    font-size: 14px;
    line-height: 20px;
  }

  &__backers-info {
    color: $grey-color;
    font-size: 12px;
    line-height: 22px;
  }
}

.price-selector {
  width: 197px;
  height: 56px;
  color: $dark-color;
  border: 1px solid $dark-color;
  border-radius: 8px;
  font-size: 24px;
}

.price-info {
  color: $dark-color;
  font-size: 24px;
  line-height: 24px;

  &__tax {
    font-size: 16px;
    white-space: nowrap;
    line-height: 20px;
  }
}
</style>
